// src/components/Apm/Currency/Currencies.js

import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useMediaQuery, useTheme } from '@mui/material';

import { useGetCurrenciesQuery } from '../../../redux/features/currencyApi';
import { columnsCurrencies } from '../Tables/Columns/columnsCurrencies';
import TableSimple from '../Tables/TableSimple';

const Currencies = () => {
  const { t } = useTranslation();

  const theme = useTheme();

  const smMediaDown = useMediaQuery(theme.breakpoints.down('sm'));

  const { data: currencies = [], isLoading, isFetching, isError, error, status, refetch } = useGetCurrenciesQuery();

  console.log('CURRENCIES QUERY STATE', {
    currencies,
    status,
    isLoading,
    isFetching,
    isError,
    error,
  });

  const updatedColumns = useMemo(() => {
    const columns = columnsCurrencies();

    if (!smMediaDown) {
      return columns;
    }

    return columns.filter((column) => column.id === 'currencycode' || column.id === 'currency_name');
  }, [smMediaDown]);

  const handleRefresh = useCallback(async () => {
    await refetch().unwrap();

    toast.success(() => t('toast.currency_list_updated'));
  }, [refetch, t]);

  console.log('CURRENCIES RENDER', currencies);

  return (
    <TableSimple
      resource="currencies"
      columns={updatedColumns}
      data={currencies}
      isFetching={isFetching}
      onRefresh={handleRefresh}
    />
  );
};

export default Currencies;
